import { inject } from "@angular/core";
import { TransactionStoreService } from "@bitwarden/web-vault/app/services/store/transaction/transaction.store.service";
import { SignalSubscriptionImpl } from "../data-subscription";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { CategoryView } from "@bitwarden/web-vault/app/models/view/category/category.view";

export type CategoryTableView = CategoryView & {
  linkedTransactionCount: number;
  rightChevron: boolean;
};

export type TableSource = CategoryTableView;

/**
 * This class only need to deal with angular dependency
 * and the core logic is in getAccountTableViews function which can be easily unit tested
 */
export class CategoryTableSubscription extends SignalSubscriptionImpl<TableSource[]> {
  private transactionStore = inject(TransactionStoreService);
  private userStore = inject(UserStoreService);

  linkedTransactionCount(selectedCategoryId: string) {
    let count = 0;
    this.transactionStore.enrichTransaction.collection().filter((transaction) => {
      if (transaction.c_categories.includes(selectedCategoryId)) {
        count++;
      }
    });
    return count;
  }

  get source() {
    return this.userStore.categories.categoryViewsSorted().map(
      (category) =>
        ({
          ...category,
          linkedTransactionCount: this.linkedTransactionCount(category.id),
          rightChevron: true,
        }) as CategoryTableView,
    );
  }
}
